import { useEffect } from 'preact/hooks';

// only for android
// attach event listener for back button press
function useAndroidBackPress(ref, callback) {
  useEffect(() => {
    document.addEventListener(window.__CAAS__.events.pressBack, callback);

    return () => {
      document.removeEventListener(window.__CAAS__.events.pressBack, callback);
    };
  }, [ref]);
}
export default useAndroidBackPress;
